import { EpiPage, LoadingStatus } from '@api/types';
import {
  AfterHeaderContentArea,
  BreadCrumbsBlock,
  FooterContentArea,
  HeaderContentArea,
  MainContentArea,
  Meta,
} from '@components';
import { CartProvider } from '@context/CartContext';
import { Box } from '@mui/material';
export type ContentPageLayoutProps = {
  page?: EpiPage;
  status?: LoadingStatus;
  children?: React.ReactNode;
};

/**
 * Default layout with Header, AfterHeader, Main and Footer areas.
 */
export const ContentPageLayout = ({ page = {}, status = {}, children }: ContentPageLayoutProps) => {
  return (
    <CartProvider>
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Meta page={page} />
        <HeaderContentArea />
        <AfterHeaderContentArea />
        <BreadCrumbsBlock />
        <MainContentArea page={page} status={status}>
          {children}
        </MainContentArea>
        <Box sx={{ mt: 'auto' }} className='footer-section'>
          <FooterContentArea />
        </Box>
      </Box>
    </CartProvider>
  );
};
